import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { SortOrder } from 'src/app/enum/sort-order';
import { SentEnvelopeFilter } from 'src/app/envelope/model/sent-envelope-filter';
import { EnvelopeService } from 'src/app/envelope/services/envelope.service';
@Injectable({
  providedIn: 'root',
})
export class DashboardResolver implements Resolve<Observable<any>> {
  startEnvelopeFilter: SentEnvelopeFilter;
  constructor(
    private envelopeService: EnvelopeService  ) {
    this.startEnvelopeFilter = new SentEnvelopeFilter();
    this.startEnvelopeFilter.status = SentEnvelopeStatus.pending;
    this.startEnvelopeFilter.skip = 0;
    this.startEnvelopeFilter.take = 25;
    this.startEnvelopeFilter.sortOrder = SortOrder.Ascending;
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Observable<never> {
    return forkJoin({
      statusCounter: this.envelopeService
        .getSentEnvelopeStatusCounter(this.startEnvelopeFilter)
        .pipe(catchError(this.errorCalling)),
      list: this.envelopeService
        .filterElements(this.startEnvelopeFilter)
        .pipe(catchError(this.errorCalling)),
    });
  }

  errorCalling = (err) => {
    console.log('Error Getting data: ', err);
    return err;
  };
}
